export function getColumnValueFromRowHTML(rowHTML, column) {
    var row = document.createElement('tr');
    column = column.replace(/\./g, '\\.');
    row.innerHTML = rowHTML;
    var col = row.querySelector("td.column-" + column);
    if (col) {
        var invalidElements = col.querySelectorAll('.row-actions');
        if (invalidElements) {
            invalidElements.forEach(function (element) {
                element.remove();
            });
        }
        return col.innerHTML;
    }
    return '';
}
